module.exports = __webpack_public_path__ + "static/media/12UNCTAD14.3eeea863.jpg";